import { ParentType } from './contribution.type';

export class ContributionRequest {
  Id: number;
  BundleId: number;
  ApplyToAllPackages: boolean;
  DifferentContributionPerCarrier: boolean;
  ContributionAmountTypeId: number; //1, 2, 3, 4, //None, Percent, FlatAmount, EEPaysFlatAmount
  SelectedContributionAmountType: string; //None, Percent, FlatAmount, EEPaysFlatAmount
  Title: string;
  IsWrap: boolean;
  TotalPremium: number;
  IsAcknowledged: boolean;
  HasDependents: boolean;
  ParentApp: string; //ParentType;
  SupportedContributionTypes: string[];
  Carriers: Carrier[];
  ContributionItems: ContributionCarrier[];
  IsContributionItem: boolean;
  OOSEmployeesExist: boolean;
  EnableApplyToAllPackages: boolean;
  RequirePayPeriod:boolean;
  PayPeriodTypeId:number;
}

export class ContributionResponse {
  Id: number;
  BundleId: number;
  ApplyToAllPackages: boolean;
  DifferentContributionPerCarrier: boolean;
  ContributionAmountTypeId: number;
  IsWrap: boolean;
  IsAcknowledged: boolean;
  HasDependents: boolean;
  ContributionItems: ContributionCarrier[];
}

export class Carrier {
  CarrierId: number;
  CarrierName: string;
  Thresholds: ThresholdItems;
  PlanList: BasicPlan[];
  OOSEmployeeList: EmployeeMember[];
}
export class ContributionCarrier {
  CarrierId: number;
  BundleId: number;
  CarrierName: string;
  ContributionAmountTypeId: number; //1, 2, 3, 4, // None, Percent, FlatAmount, EEPaysFlatAmount
  ContributionBasisType: number; //1, 2, 3, 4, // SelectedPlan, AnyPlan, LowestCostPlan, NoContribution
  EmployeeContributionPercent: number;
  EmployeeContributionAmount: number;
  DependentContributionPercent: number;
  DependentContributionAmount: number;
  IsRollExcess: boolean; //true/false, // can be true only when contributionAmountTypeId = 3
  EmployerSelectedPlanId: number; // will contain value only if ContributionBasisType = 1 SelectedPlan
  EmployerSelectedPlanName: string; // will contain value only if ContributionBasisType = 1 SelectedPlan
  IsEEPaysAllDependentAmount: boolean; // can be true only if ContributionAmountTypeId = 4 EEPaysFlatAmount
  SelectedFlatContributionAmountType: string;
  SelectedEmployerContributionType: string;
  OOSEmployeeList: EmployeeMember[];
  IsAcknowledged: boolean;
  showOOS: boolean;
}

export class EmployeeMember {
  MemberId: number;
  EmployeeName: string;
  EmployeeContributionPercent: number;
  EmployeeContributionAmount: number;
  DependentContributionPercent: number;
  DependentContributionAmount: number;
  SelectedPlanId: number;
  SelectedPlanName: string;
  IsEEPaysAllDependentAmount: boolean;
  EligiblePlanList: BasicPlan[];
}

export class BasicPlan {
  BundleId: number;
  NQSPlanId: number;
  BundlePlanId: number;
  MediumName: string;
  Network: string;
  BenefitType: string;
  MetalTierType: string;
  TotalPremium: number;
}
export class InputValidationReturn {
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  Status: boolean = true;
  ValidateFailed = '';
}

export class DollarThreshold {
  Max: number;
  Min: number;
}

export class PercentThreshold {
  ContributionTypeId: number;
  Max: number;
  Min: number;
}
export class ThresholdItems {
  Dollar: DollarThreshold;
  Percent: PercentThreshold[];
}

export class ContributionRuleDetail {
  PackageId: number;
  ContributionAmtType: string;
  ContributionAmtTypeId: number;
  EmployerContributionType: number;
  EmployerContributionTypeId: number;
  MinEEContributionAmt: number;
  MaxEEContributionAmt: number;
  MinDepContributionAmt: number;
  MaxDepContributionAmt: number;
}

export class CarrierPackageId {
  CarrierId: number;
  OrionPackageId: number;
  PackageId: number;
  CoverageTypeId: number;
}

export class PackageContributionRules {
  PackageId: number;
  CarrierId: number;
  OrionPackageId: number;
  ContributionRules: ContributionRuleDetail[];
}
